import { Checkbox, Space, type TableColumnsType, Tag } from 'antd';
import { t } from 'i18next';
import { ServiceAvailabilityBulkActionsEnum } from 'pos-shared/models/locationSchema.ts';
import type {
  ServiceAvailability,
  ServiceAvailabilityConfigFEModel,
  ServiceMatrixFEModel,
} from 'pos-shared/models/serviceAvailabilitySchema.ts';

export const getServiceAvailabilityTableColumns = (
  data: ServiceAvailabilityConfigFEModel | undefined,
  toggleDay: (day: string, checked: boolean) => void,
  toggleAvailability: (
    serviceId: string,
    timeslotId: string,
    checked: boolean
  ) => void
): TableColumnsType<ServiceMatrixFEModel> => {
  if (!data) {
    return [];
  }

  const dynamicColumns: TableColumnsType<ServiceMatrixFEModel> = [
    ...data.availableTimeslots
      .map(
        (availableTimeslot) =>
          [
            {
              title: (
                <Space
                  style={{
                    width: '100%',
                    textAlign: 'center',
                  }}
                  direction="vertical"
                  align="center"
                >
                  <Checkbox
                    onChange={(evt) =>
                      toggleDay(availableTimeslot.day, evt.target.checked)
                    }
                  />
                  {availableTimeslot.day}
                </Space>
              ),
              key: 'times',
              render: (_, record) => {
                return (
                  <Space
                    direction="horizontal"
                    align="center"
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                    }}
                    wrap
                  >
                    {availableTimeslot.availability.map((time) => {
                      const serviceId = record.productCategoryId;

                      const cellInfo: ServiceAvailability | undefined =
                        record?.availabilities?.find((availability) =>
                          availability.timeslots.find(
                            (timeslot) =>
                              timeslot.timeslotId === time?.timeslotId
                          )
                        );

                      const isChecked: boolean =
                        cellInfo?.timeslots?.find(
                          (x) => x.timeslotId === time?.timeslotId
                        )?.isSelected || false;

                      return (
                        <Tag.CheckableTag
                          key={`${serviceId}-${time?.timeslotId}-${time}`}
                          checked={isChecked}
                          style={{
                            color: isChecked
                              ? 'rgba(6, 17, 120, 1)'
                              : 'rgba(0,0,0,0.88)',
                            backgroundColor: isChecked
                              ? 'rgba(214, 228, 255, 1)'
                              : 'rgba(0,0,0,0.04)',
                          }}
                          onChange={(checked) =>
                            toggleAvailability(
                              serviceId,
                              time.timeslotId,
                              checked
                            )
                          }
                        >
                          {time.time}
                        </Tag.CheckableTag>
                      );
                    })}
                  </Space>
                );
              },
            },
          ] as TableColumnsType<ServiceMatrixFEModel>
      )
      .flat(),
  ];

  return [
    {
      title: t('locations.capabilities'),
      key: 'productCategoryId',
      dataIndex: 'productCategoryTitle',
    },
    ...dynamicColumns,
  ];
};

export const getBulkActionsOptions = () => {
  const opts = ServiceAvailabilityBulkActionsEnum.options;

  return opts.map((option) => ({
    label: t(`locations.bulkActions.${option}`),
    key: option,
  }));
};
